import { TextField, styled } from "@mui/material";
import React, { useState, useEffect } from "react";

const CustomInputField = styled(TextField)({
  // Your styling here
});

const CustomInput = ({ maxLength, value, onChange, ...props }) => {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    // Update the input value when the parent updates the value prop
    setInputValue(value);
  }, [value]);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    // Enforce the character limit
    if (maxLength && inputValue.length > maxLength) {
      return;
    }
    setInputValue(inputValue);
    onChange(e); // Call the original onChange function
  };

  return (
    <CustomInputField
      {...props}
      value={inputValue}
      onChange={handleInputChange}
    />
  );
};

export default CustomInput;
